import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = { class: "modal-container-task-box-group" }
const _hoisted_3 = { class: "modal-body mtop-10" }
const _hoisted_4 = { class: "row w-full mtop-10" }
const _hoisted_5 = { class: "col-0-8 colend mright-04" }
const _hoisted_6 = { class: "main-m" }
const _hoisted_7 = { class: "row w-full mtop-10" }
const _hoisted_8 = { class: "col-0-8 colend mright-04" }
const _hoisted_9 = { class: "main-m" }
const _hoisted_10 = { key: 0 }

import { ref, watch } from "vue";
import { useI18n } from 'vue-i18n';
import { AddOrUpdateTaskBoxRequest, TaskBoxLightResponse, TaskModuleTypeEnum } from '@/apiGenerate/medserver';
import InputText from 'primevue/inputtext';
import Select from 'primevue/select';


export default /*@__PURE__*/_defineComponent({
  __name: 'esTaskBoxForm',
  props: {
    isOpen: { type: Boolean },
    header: {},
    taskBoxLightResponse: {},
    confirmMethod: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const { t } = useI18n();

const taskModuleTypes = ref<string[]>(Object.values(TaskModuleTypeEnum) as string[]);

const addOrUpdateTaskBoxRequest = ref<AddOrUpdateTaskBoxRequest>({
  title: undefined,
  moduleType: undefined
});

/**
 * Emits the `modal-close` event with the current task box request data.
 * Typically called when confirming the form submission.
 */
const confirmFormModal = async () => {
  try {
    await props.confirmMethod(addOrUpdateTaskBoxRequest.value);
  } catch {
    throw t('error.DEFAULT');
  }
}

/**
 * Emits the `modal-close` event without any payload.
 * Typically called when closing the form without saving changes.
 */
const closeFormModal = () => {
  emit('modal-close');
}

watch(
  () => props.isOpen,
  () => {
    if (props.isOpen && props.taskBoxLightResponse) {
      addOrUpdateTaskBoxRequest.value = {
        id: props.taskBoxLightResponse.id,
        title: props.taskBoxLightResponse.title,
        moduleType: props.taskBoxLightResponse.moduleType
      }
    } else {
      addOrUpdateTaskBoxRequest.value = {
        id: undefined,
        title: undefined,
        moduleType: undefined
      }
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_es_modal_header, { header: _ctx.header }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_unref(t)('settings.label.task.taskbox.data.title')), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(InputText), {
                type: "text",
                size: "small",
                modelValue: addOrUpdateTaskBoxRequest.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addOrUpdateTaskBoxRequest.value.title) = $event)),
                class: "w-full"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(t)('settings.label.task.taskbox.data.module')), 1),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "main-alert" }, "*", -1))
                ])
              ]),
              _createVNode(_unref(Select), {
                modelValue: addOrUpdateTaskBoxRequest.value.moduleType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addOrUpdateTaskBoxRequest.value.moduleType) = $event)),
                options: taskModuleTypes.value,
                size: "small",
                class: "w-full"
              }, {
                value: _withCtx((slotProps) => [
                  (slotProps.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(t)('settings.label.task.taskbox.moduleType.' + slotProps.value.toUpperCase())), 1))
                    : _createCommentVNode("", true)
                ]),
                option: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(_unref(t)('settings.label.task.taskbox.moduleType.' + slotProps.option.toUpperCase())), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ])
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: () => confirmFormModal()
          }, null, 8, ["confirmModalMethod"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})